module.exports = __webpack_public_path__ + "img/m_mc.9557c400.png";